// extracted by mini-css-extract-plugin
export default {"search-top-label":"SearchHeader_search-top-label__taobm","searchContainer":"SearchHeader_searchContainer__qEijI container","text":"SearchHeader_text__Lyc4h"};